import { createTheme } from '@mui/material';
import { getPortalThemeTokens } from 'src/PlatformPortal/theme';
import { PlatformPortal } from 'src/PlatformPortal/types';
import typographies from 'src/theme/typographies';

export const createRegisterTheme = (portal?: PlatformPortal | null) => {
  const tokens = getPortalThemeTokens(portal);

  return createTheme({
    typography: {
      fontFamily: tokens.fontFamily,
      ...typographies,
    },
    palette: {
      primary: {
        main: tokens.colors.primary,
        contrastText: '#FFF',
      },
      secondary: {
        main: '#FFF',
        contrastText: tokens.colors.primary,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '28px',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '15px',
            textTransform: 'none',
            padding: '16px',
            height: '48px',
            boxShadow: 'none',

            '&:hover': {
              boxShadow: 'none',
              backgroundColor: tokens.colors.primaryLight,
            },
          },
          textSecondary: {
            color: tokens.colors.textPrimary,
            border: '1px solid #D9D9D9',
          },
        },
      },

      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
              '&.Black': {
                borderColor: 'black',
              },
            },
          },
        },
      },
    },
  });
};

export const registerTheme = createRegisterTheme(null);
